import { render, staticRenderFns } from "./header.vue?vue&type=template&id=52ff5928&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=52ff5928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff5928",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogChip: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/chip.vue').default,BlogArticleShare: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/article/share.vue').default})
